.root {
}
.picker{
  //width: 260px !important;
}
